import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished'
import { filter } from 'lodash'
import { AgGridReact, AgGridColumn } from 'ag-grid-react'

import gridOptions from './gridOptions'
import agGridCSS from './agGridCSS'

import { updateSettings } from '../../settings'
import { fetchDimensions, getDimensions } from './redux'

import { media } from '../../styles/utils';
import { green, greenSecondary, cream, cream2 } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';
import CloseIcon from 'svg-react-loader?name=Icon!../../assets/icons/hamburger-close.svg'

class Dimensions extends Component {

    constructor(props) {
        super(props);
        this.grid = React.createRef();
    }

    state = {
        sidebarActive: false,
        sidebarData: null
    }

    static fetchData(store, match) {
        return store.dispatch(fetchDimensions());
    }
    
    componentWillMount = () => {
        const { updateSettings } = this.props;

        this.props.fetchDimensions()

        updateSettings({
            pageTitle: 'Product Dimensions'
        })
    }

    onSearchChange = (event) => {
        if (this.grid.current.api) {
            this.grid.current.api.setQuickFilter(event.target.value)
        }
	}

    renderSearch = () => {
        return (
            <Search>   
                <SearchIcon/>
                <SearchInput
                    placeholder="Search for product or size..."
                    onChange={this.onSearchChange}
                />
            </Search>
        )
    }

    renderTableHeader = (data) => {

        return (
            <TableHeader>
                {data.displayName}
            </TableHeader>
        )
    }

    renderGrid = () => {
        const { dimensions } = this.props;

        return (
            <AgGridReact
                ref={this.grid} 
                gridOptions={gridOptions}
                rowData={dimensions.data.products}
                onCellClicked={this.onCellClick}
            />
        )
    }
    
    onCellClick = (cellData) => {
        const data = cellData.data;

        //console.log(data)

        this.setState({
            sidebarActive: true,
            sidebarData: {
                title: data.title,
                edit: data.edit,
                image: data.image.sizes.medium_large[0],
                meta: [
                    {
                        label: 'Category',
                        value: data.category[0]
                    },
                    {
                        label: 'Capacity',
                        value: data.capacity,
                        unit: data.capacityMeasurement
                    },
                    {
                        label: 'L (mm)',
                        value: data.depthMillimeters,
                        unit: 'mm'
                    },
                    {
                        label: 'W (mm)',
                        value: data.widthMillimeters,
                        unit: 'mm'
                    },
                    {
                        label: 'H (mm)',
                        value: data.heightMillimeters,
                        unit: 'mm'
                    },
                    {
                        label: 'L (in)',
                        value: data.depthMillimeters,
                        unit: 'in'
                    },
                    {
                        label: 'W (in)',
                        value: data.widthMillimeters,
                        unit: 'in'
                    },
                    {
                        label: 'H (in)',
                        value: data.heightMillimeters,
                        unit: 'in'
                    },
                ]
            }
        })
    }

    renderSidebar = () => {
        const { sidebarActive, sidebarData } = this.state;

        return (
            <Sidebar
                active={sidebarActive}
            >
                {sidebarData && (
                    <React.Fragment>
                        <Heading>{sidebarData.title}</Heading>

                        <Image
                            src={sidebarData.image}
                        />
                    
                        {sidebarData.meta.map((item) => {
                            if (item.value) return (
                                <Meta>
                                    <Label>{item.label}</Label>
                                    <Value>
                                        {item.value}
                                        {item.unit}
                                    </Value>
                                </Meta>
                            )
                        })}

                        <Edit
                            href={sidebarData.edit}
                            target={'_blank'}
                        >
                            Edit 
                        </Edit>

                        <Close
                            onClick={() => this.setState({sidebarActive: false})}
                        >
                            <CloseIcon/>
                        </Close>
                        
                    </React.Fragment>
                )}
            </Sidebar>
        )
    }
    
    render() {
        const { dimensions } = this.props;
        
        return (
            <Container>
                {dimensions.data && this.renderSearch()}
                {dimensions.data && this.renderGrid()}
                {this.renderSidebar()}
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(100vh - 65px); 
    position: relative;

    > * {
        width: 100%;
    }
`

// Sidebar

const Heading = styled.div`
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: bold;
    padding-right: 24px;
`

const Close = styled.div`
    position: absolute;
    top: 17px;
    right: 14px;
    width: 16px;
    cursor: pointer;
    ${hoverState}
`

const Label = styled.div`
    width: 150px;
`

const Value = styled.div``

const Image = styled.img`
    max-height: 140px;
    max-width: 130px;
    width: auto;
    height: auto;
    margin-bottom: 32px;
`

const Meta = styled.div`
    display: flex;
    font-size: 12px;

    &:not(:last-child) {
        margin-bottom: 4px;
    }
`

const Edit = styled.a`
    margin-top: 24px;
    padding: 0.4rem 0.5rem;
    border: 1px solid;
    text-decoration: none;
    font-size: 12px;
    cursor: pointer;
    ${hoverState}
`

const Sidebar = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    width: 25%;
    height: calc(100vh - 65px);
    border: 1px solid black;
    border-top: 0;
    border-right: 0;
    background: ${cream};
    padding: 14px;
    transform: translateX(100%);
    transition: transform 0.35s ease;
    box-sizing: border-box;
    min-width: 476px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    ${props => {
        if (props.active) return css`
            transform: translateX(0);
        `
    }}
    

    ${media.phone`
        width: 100%;
        min-width: 0;
        border-left: 0;
    `}
`

// Search

const Search = styled.div`
    background: ${cream2};
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    border-bottom: 1px solid;
    flex: 1 0 auto;
`;

const SearchIcon = styled.div`
    
`;

const SearchInput = styled.input`
    background: none;
    border: none;

    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    font-size: 24px;
    line-height: 34px;
    padding: 0.8rem 1rem 0.8rem 0.8rem;
    
    &, &::placeholder {
        color: black;
    }

    &:focus { 
        outline: none;
    }

    ${media.phone`
        font-size: 22px;
    `}
`

injectGlobal`
    ${agGridCSS}
    
    /* Table header */

    .ag-header-viewport {
        border-bottom: 1px solid black;
    }
    
    .ag-header-cell {
        display: flex;
        align-items: center;
        padding-bottom: 1px;
        box-sizing: border-box;
        padding-left: 10px;
        border-bottom: 1px solid black;

        span.ag-icon-menu {
            margin-left: 5px;
        }
    }

    /* Cell padding */
    
    .ag-cell {
        padding-left: 10px;
        font-size: 12px;

        &:focus {
            outline: none;
        }
    }

    /* Filter grid */

    .ag-body-container {
        padding-top: 8px;
        padding-bottom: 16px;
    }

    /* Floating filter */

    .ag-filter-body-wrapper {
        border: 1px solid black;
        padding: 13px;
        background: ${cream};

        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        select { 
            border: 1px solid black;
            margin-bottom: 6px;
            transform: translateX(-4px);
            height: 28px;
            font-size: 16px;
            width: calc(100% - 2px);
        }

        input {
            border: 1px solid black;
            height: 28px;
            padding-left: 4px;

            &, &::placeholder {
                color: black;
                font-size: 16px;
            }
        }
    }

    .ag-row {
        .ag-cell {
            display: flex;
            align-items: center;
            /* text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap; */
        }

        &:hover {
            background: ${cream2};
        }

        &.ag-row-selected {
            background: ${cream2};
        }
    }
    
`

const mapDispatchToProps = dispatch => ({
    fetchDimensions() {
        dispatch(fetchDimensions())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    dimensions: getDimensions(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Dimensions);



// WEBPACK FOOTER //
// ./client/modules/Dimensions/Dimensions.js